/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import ConsumerSearchBarGridItem from 'bundles/composable-page-header-consumer/components/ConsumerSearchBarGridItem';
import LegacyExploreMegaMenuGridItem from 'bundles/composable-page-header-consumer/components/LegacyExploreMegaMenuGridItem';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavLinkGridItem from 'bundles/composable-page-header/components/grid-items/NavLinkGridItem';
import UnauthenticatedActionsGridItem from 'bundles/composable-page-header/components/grid-items/UnauthenticatedActionsGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import { logInButtonProps, signUpButtonProps } from 'bundles/composable-page-header/constants';
import { getShouldShowCourseraPlusEntrypointInNav } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  flexGrow: css`
    flex-grow: 1;
  `,
};

const LoggedOutConsumerDesktopMainNav = () => {
  const showCPlusLink = getShouldShowCourseraPlusEntrypointInNav();

  return (
    <MainNavigationWrapper>
      <Grid item md={8} lg={7} container alignItems="center" spacing={16}>
        <Grid item>
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} className="c-logo" />
        </Grid>
        <Grid item>
          <LegacyExploreMegaMenuGridItem renderMenuOnServer />
        </Grid>
        <Grid item css={styles.flexGrow}>
          <ConsumerSearchBarGridItem />
        </Grid>
      </Grid>
      <Grid item container md={4} lg={5} alignItems="center" justifyContent="flex-end" wrap="nowrap">
        {showCPlusLink ? (
          <NavLinkGridItem
            label={_t('Coursera Plus')}
            href="/courseraplus"
            name="coursera_plus"
            trackingName="logged_out_coursera_plus"
          />
        ) : (
          <React.Fragment>
            <NavLinkGridItem
              label={_t('Online Degrees')}
              href="/degrees"
              name="online_degrees"
              trackingName="logged_out_online_degrees"
            />
            <NavLinkGridItem
              label={_t('Careers')}
              href="/career-academy"
              name="online_career"
              trackingName="logged_out_career_academy"
            />
          </React.Fragment>
        )}
        <UnauthenticatedActionsGridItem buttons={[logInButtonProps(), signUpButtonProps()]} />
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerDesktopMainNav;
